// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__KPr3_","label":"CategoryService_label__3z_px","location":"CategoryService_location__19aNy"};